const AccountCreateRouter = [
  {
    path     : '/account/create',
    component: () => import ('@/app/layout/view/layout-default.vue'),
    redirect : '/account/create/agree',
    children : [
      {
        path     : 'agree',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-agree.vue'),
      },
      {
        path     : 'agree-agent',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-agree-agent.vue'),
      },
      {
        path     : 'forms',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-forms.vue'),
      },
      {
        path     : 'forms-sns',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-forms-sns.vue'),
      },
      {
        path     : 'forms-ctn',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-forms-ctn.vue'),
      },
      {
        path     : 'result',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/create/view/account-create-result.vue'),
      }
    ]
  }
];

export default AccountCreateRouter;
